import { createAction, props } from '@ngrx/store';
import { CheckbooksTypesResponse } from '../models/search-checkbooks.model';

export const GroupTemplateCodeChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Group Template Code Changed',
  props<{ code: string }>(),
);

export const GroupTemplateCodeValidationStatus = createAction(
  '[Search Group Templates: Checkbook Group Template]: Group Template Code Validation Status',
  props<{ isInvalid: boolean }>(),
);

export const SelectedTypeChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Selected Type Changed',
  props<{ selectedTypeId: number | null }>(),
);

export const PrefixChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Prefix Changed',
  props<{ prefix: string }>(),
);

export const RemarksChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Remarks Changed',
  props<{ remarks: string }>(),
);

export const LoadCheckbookGroupTemplateCols = createAction(
  '[Search Group Templates: Checkbook Group Template]:Load Checkbook Group Template Columns',
  props<{ displayedColumns: { [label: string]: string } }>(),
);

export const GetCheckbooksTypes = createAction(
  '[Search Group Templates: Checkbook Group Template]: Get Checkbooks Types',
);

export const GetCheckbooksTypesSuccess = createAction(
  '[Search Group Templates: Checkbook Group Template]: Get Checkbooks Types Success',
  props<{ response: CheckbooksTypesResponse[] }>(),
);

export const GetCheckbooksTypesFailed = createAction(
  '[Search Group Templates: Checkbook Group Template]: Get Checkbooks Types Failed',
  props<{ error: any }>(),
);

export const AddRow = createAction('[Search Group Templates: Checkbook Group Template]: Add Row');

export const DeleteRow = createAction(
  '[Search Group Templates: Checkbook Group Template]: Delete Row',
  props<{ id: string }>(),
);

export const DeleteAll = createAction(
  '[Search Group Templates: Checkbook Group Template]: Delete All',
);

export const GetCouponSet = createAction(
  '[Search Group Templates: Checkbook Group Template]: Get CouponSet',
);

export const GetCouponSetSuccess = createAction(
  '[Search Group Templates: Checkbook Group Template]: Get CouponSet Success',
  props<{ response: any }>(),
);

export const GetCouponSetFailed = createAction(
  '[Search Group Templates: Checkbook Group Template]: Get CouponSet Failed',
  props<{ error: any }>(),
);

export const SelectedCouponSetChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Selected CouponSet Changed',
  props<{ couponSetId: number | null; id: string }>(),
);

export const BatchNumberChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Batch Number Changed',
  props<{ couponBatchNumber: number | null; id: string }>(),
);

export const CheckbookPrefixChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Checkbook Prefix Changed',
  props<{ bookCouponPrefix: number | null; id: string }>(),
);

export const InputChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Input Changed',
  props<{ input: string; column: string; row: any }>(),
);

export const Create = createAction('[Search Group Templates: Checkbook Group Template]: Create');

export const CreateSuccess = createAction(
  '[Search Group Templates: Checkbook Group Template]: Create Success',
  props<{ response: any }>(),
);

export const CreateFailed = createAction(
  '[Search Group Templates: Checkbook Group Template]: Create Failed',
  props<{ error: any }>(),
);

export const SubmitCheckbookGroupTemplateData = createAction(
  '[Search Group Templates: Checkbook Group Template]: Submit Checkbook Group Template Data',
);

export const EditCheckbookGroupTemplate = createAction(
  '[Search Group Templates: Checkbook Group Template]: Edit Checkbook Group Template',
  props<{ data: any }>(),
);

export const UpdateCheckbookGroupTemplate = createAction(
  '[Search Group Templates: Checkbook Group Template]: Update CheckbookGroupTemplate',
);

export const UpdateCheckbookGroupTemplateSuccess = createAction(
  '[Search Group Templates: Checkbook Group Template]: Update Checkbook Success',
  props<{ response: any }>(),
);

export const UpdateCheckbookGroupTemplateFailed = createAction(
  '[Search Group Templates: Checkbook Group Template]: Update Checkbook Failed',
  props<{ error: any }>(),
);

export const InactiveChanged = createAction(
  '[Search Group Templates: Checkbook Group Template]: Inactive Changed',
  props<{ inactive: boolean }>(),
);
